const initialState = {
  notifications: [],
  unreadCount: 0,
  categoryConfig: [],
  preferences: [],
  isLoading: false,
  isSettingsLoading: false,
  isPreferencesLoading: false,
  hasMore: true,
  page: 1,
  activeFilter: 'all',
  activeCategory: '',
  error: null
};

const Notification = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'GET_NOTIFICATIONS':
      // Reason: clear stale rows when the filter tab or category changes so the loader shows until fresh data arrives
      return {
        ...state,
        isLoading: true,
        error: null,
        notifications: payload && ((payload.filter && payload.filter !== state.activeFilter) || (payload.category !== undefined && payload.category !== state.activeCategory)) ? [] : state.notifications,
        activeFilter: payload && payload.filter ? payload.filter : state.activeFilter,
        activeCategory: payload && payload.category !== undefined ? payload.category : state.activeCategory
      };

    case 'GET_NOTIFICATIONS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        notifications: payload.page === 1
          ? payload.notifications
          : [...state.notifications, ...payload.notifications],
        hasMore: payload.hasMore,
        page: payload.page,
        activeFilter: payload.filter || state.activeFilter
      };

    case 'GET_NOTIFICATIONS_FAILURE':
      return { ...state, isLoading: false, error: payload };

    case 'GET_UNREAD_COUNT_SUCCESS':
      return { ...state, unreadCount: payload.count };

    case 'MARK_AS_READ_SUCCESS':
      return {
        ...state,
        notifications: state.notifications.map(n =>
          n._id === payload._id ? { ...n, isRead: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1)
      };

    case 'MARK_AS_UNREAD_SUCCESS':
      return {
        ...state,
        notifications: state.notifications.map(n =>
          n._id === payload._id ? { ...n, isRead: false } : n
        ),
        unreadCount: state.unreadCount + 1
      };

    case 'MARK_ALL_AS_READ_SUCCESS':
      return {
        ...state,
        notifications: state.notifications.map(n => ({ ...n, isRead: true })),
        unreadCount: 0
      };

    case 'ARCHIVE_NOTIFICATION_SUCCESS':
      return {
        ...state,
        notifications: state.notifications.filter(n => n._id !== payload._id),
        unreadCount: payload.wasUnread ? Math.max(0, state.unreadCount - 1) : state.unreadCount
      };

    case 'DELETE_NOTIFICATION_SUCCESS':
      return {
        ...state,
        notifications: state.notifications.filter(n => n._id !== payload._id),
        unreadCount: payload.wasUnread ? Math.max(0, state.unreadCount - 1) : state.unreadCount
      };

    case 'ADD_NEW_NOTIFICATION':
      return {
        ...state,
        notifications: [payload, ...state.notifications],
        unreadCount: state.unreadCount + 1
      };

    case 'GET_NOTIFICATION_SETTINGS':
      return { ...state, isSettingsLoading: true };

    case 'GET_NOTIFICATION_SETTINGS_SUCCESS':
      return { ...state, categoryConfig: payload || [], isSettingsLoading: false };

    case 'GET_NOTIFICATION_SETTINGS_FAILURE':
      return { ...state, isSettingsLoading: false };

    case 'GET_NOTIFICATION_PREFERENCES':
      return { ...state, isPreferencesLoading: true };

    case 'GET_NOTIFICATION_PREFERENCES_SUCCESS':
      return { ...state, preferences: payload.preferences || [], isPreferencesLoading: false };

    case 'GET_NOTIFICATION_PREFERENCES_FAILURE':
      return { ...state, isPreferencesLoading: false };

    case 'UPDATE_NOTIFICATION_PREFERENCES_SUCCESS':
      return { ...state, preferences: payload.preferences || [] };

    default:
      return state;
  }
};

export default Notification;
